import { Org, Role, User } from '../../../common/src/model.ts';
import { useCurrentOrg } from './use_current_org.tsx';
import { useUser } from './use_user.tsx';

export function useUserAttributes(): {
  isInternalUser: boolean;
  isOrgAdmin: boolean;
  isStaff: boolean;
} {
  const { currentOrg } = useCurrentOrg();
  const { user } = useUser();

  const isInternalUser = !!user?.internal;
  const isOrgAdmin = isAdminOfOrg(user, currentOrg);
  const isStaff = Boolean(user?.roles?.find(({ orgId, role }) => orgId === currentOrg?.id && role === Role.Staff));

  return { isInternalUser, isOrgAdmin, isStaff };
}

export function isAdminOfOrg(user: User | undefined, org: Org | undefined): boolean {
  if (org === undefined) {
    return false;
  }
  return Boolean(user?.roles?.find(({ orgId, role }) => orgId === org?.id && role === Role.Administrator));
}
